import React, { useState, useEffect } from "react";
import { TextField, Button, Container, Typography, Box } from "@mui/material";
import styled from "styled-components";
import API from "../../../utils/api";
import { Autocomplete } from "@mui/material";

const FormContainer = styled(Container)`
  background-color: #1b1a2ea9;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0px 10px 10px 0px rgba(9, 5, 29, 0.171);
  backdrop-filter: blur(15px);
  color: white;
`;

const StyledTextField = styled(TextField)`
  & .MuiInputBase-root {
    color: white;
  }
  & .MuiInputLabel-root {
    color: white;
  }
  & .MuiOutlinedInput-root {
    & fieldset {
      border-color: white;
    }
    &:hover fieldset {
      border-color: #c770f0;
    }
    &.Mui-focused fieldset {
      border-color: #c770f0;
    }
  }
  margin-bottom: 1rem;
`;

const StyledButton = styled(Button)`
  background-color: #623686;
  color: white;
  margin-left: 1rem;
  margin-right: 1rem;
  &:hover {
    background-color: #6d20c5d7;
  }
`;

const SkillForm = () => {
  const [skills, setSkills] = useState([]);
  const [data, setData] = useState({
    skill: "",
    update: "",
    json_str: "",
  });

  useEffect(() => {
    API.get("/api/skills/get_names")
      .then((res) => setSkills(res.data.skills))
      .catch((err) => console.error("Failed to fetch skills", err));
  }, []);

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const CopySkillJSON = (e) => {
    e.preventDefault();
    const skillName = data.skill;
    const skillUpdate = data.update;

    API.post("/api/skills/getByName", { name: skillName })
      .then((res) => res.data)
      .then((data) => {
        const skillData = data.skill || {
          name: skillName,
          domain: "",
          rating: 0,
          summary: "",
          strengths: [],
          improvements_needed: [],
          next_steps: [],
        };

        const formattedJSON = {
          domain:
            skillData.domain ||
            "Suggest from domain list or create a new one if empty from backend",
          skill_name: skillData.name,
          previous_state: {
            summary: skillData.summary,
            rating: skillData.rating,
            next_steps: skillData.next_steps,
            strengths: skillData.strengths,
            improvements_needed: skillData.improvements_needed,
          },
          learning_update: skillUpdate || "",
        };

        return navigator.clipboard.writeText(
          JSON.stringify(formattedJSON, null, 2)
        );
      })
      .then(() => {
        alert("Skill JSON copied to clipboard!");
      })
      .catch((error) => {
        console.error("Error:", error);
        alert("Failed to fetch skill or copy JSON.");
      });
  };
  const updateSkill = async (e) => {
    e.preventDefault();
    try {
      const parsedData = JSON.parse(data.json_str);

      // Required keys for a valid skill update
      const requiredKeys = [
        "name",
        "domain",
        "summary",
        "rating",
        "next_steps",
        "strengths",
        "improvements_needed",
      ];

      // Check for missing keys
      const missingKeys = requiredKeys.filter((key) => !(key in parsedData));

      if (missingKeys.length > 0) {
        alert(`Missing keys in JSON: ${missingKeys.join(", ")}`);
        return;
      }

      // Optionally: add further validation
      if (typeof parsedData.rating !== "number") {
        alert("Rating must be a number.");
        return;
      }

      // Send to backend
      API.post("/api/skills/update", parsedData)
        .then((res) => res.data)
        .then((response) => {
          if (response.success) {
            setData({ skill: "", json_str: "", update: "" });
            alert("Skill updated successfully.");
          } else {
            console.log(response);
            alert("Skill update failed.");
          }
        });
    } catch (err) {
      console.error("Invalid JSON format:", err);
      alert("Please enter a valid JSON.");
    }
  };

  return (
    <Container className="resume-section">
      <FormContainer maxWidth="md">
        <Typography variant="h4" gutterBottom className="purple">
          🧠 Manage Skills
        </Typography>

        {/* Add Skill */}
        <form onSubmit={CopySkillJSON}>
          <Autocomplete
            options={skills.map((s) => s.name)}
            freeSolo
            value={data.skill}
            onChange={(e, value) => {
              // This is triggered when an option is selected or freeSolo input is blurred
              handleChange({ target: { name: "skill", value: value || "" } });
            }}
            renderInput={(params) => (
              <StyledTextField
                {...params}
                size="small"
                label="Skill Name"
                name="skill"
                value={data.skill}
                onChange={handleChange}
                fullWidth
                required
              />
            )}
            fullWidth
            size="small"
          />
          <StyledTextField
            size="small"
            fullWidth
            variant="outlined"
            label="what have you learned?"
            name="update"
            multiline
            minRows={5}
            maxRows={20}
            value={data.update}
            onChange={handleChange}
            type="text"
            required
          />
          <Box mt={2}>
            <StyledButton variant="contained" type="submit">
              Copy JSON
            </StyledButton>
          </Box>
        </form>

        <hr style={{ margin: "2rem 0" }} />

        {/* Update Skill */}
        <form onSubmit={updateSkill}>
          <StyledTextField
            size="small"
            fullWidth
            variant="outlined"
            label="Update JSON"
            name="json_str"
            multiline
            minRows={5}
            maxRows={20}
            value={data.json_str}
            onChange={handleChange}
            type="text"
            required
          />

          <Box mt={2}>
            <StyledButton variant="contained" type="submit">
              Update Skill
            </StyledButton>
          </Box>
        </form>
      </FormContainer>
    </Container>
  );
};

export default SkillForm;
